import React from "react";
import DataTable from "react-data-table-component";
import { fileManagerTableStyles } from "./fileManagerTableStyles";

function ContentArea({
  files,
  onSelectFile,
  goToFolder,
  clearSelectedRows,
  previewFile,
  loading,
}) {
  const getIconClass = (type) => {
    switch (type) {
      case "Folder":
        return "fa-regular fa-folder";
      case "application/pdf":
        return "fa-regular fa-file-pdf";
      case "image/jpeg":
        return "fa-regular fa-file-image";
      case "image/png":
        return "fa-regular fa-file-image";
      case "Video":
        return "fa-regular fa-file-video";
      case "text/plain":
        return "fa-regular fa-file-text";
      default:
        return "fa-regular fa-file";
    }
  };

  const columns = [
    {
      name: "Id",
      sortable: true,
      omit: true,
      selector: (row) => row.id,
      cell: (row) => <>{row.id}</>,
    },
    {
      name: "Name",
      sortable: true,
      selector: (row) => row.name,
      cell: (row) => (
        <>
          <i
            className={`${getIconClass(row.type)}`}
            style={{ marginRight: "8px", width: "10px" }}
          ></i>
          {row.name}
        </>
      ),
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
      width: "100px",
    },
    {
      name: "Size",
      selector: (row) => row.size,
      sortable: true,
      width: "100px",
    },
    {
      name: "Last Modified",
      selector: (row) => row.lastModified,
      sortable: true,
      width: "130px",
    },
  ];

  const handleRowSelect = (rows) => {
    onSelectFile(rows.selectedRows);
  };

  const handleRowClick = (row) => {
    if (loading) return;
    if (row.type === "Folder") {
      goToFolder(row.name, "");
    } else if (row.type == "Link") {
      window.open(row.name, "_blank"); // Corrected syntax
    } else {
      previewFile(row);
    }
  };

  return (
    <div className="content-area">
      {loading && (
        <div className="file-manager-loader-overlay">
          <div className="fa fa-spinner fs-7"></div>
        </div>
      )}
      <DataTable
        columns={columns}
        data={files}
        selectableRows
        onSelectedRowsChange={handleRowSelect}
        clearSelectedRows={clearSelectedRows}
        onRowClicked={handleRowClick}
        highlightOnHover
        pagination
        customStyles={fileManagerTableStyles}
      />
    </div>
  );
}

export default ContentArea;
